
import Games from "@/components/Games.vue";
import { Constants } from "@/constant/Constants";
import { Environment } from "@/data/Environment";
import { Game } from "@/data/Game";
import { Language } from "@/data/Language";
import { AppDataType, GameDataType } from "@/types";
import AbstractVue from "@/views/AbstractVue";
import { Options } from "vue-class-component";
import { EnvironmentType } from "../types/index";
import { generateNoCacheString, localStorageGetOrDefault, localStorageSet } from "@/data/Utils";

@Options({
  components: {
    Games,
  },
})
export default class KSG extends AbstractVue {
  onEnvironmentChange() {
    localStorageSet("environment_id", this.parameters.environment.id);
  }
  filterGames(): void {
    if (!this.gameFilter || this.gameFilter.trim() === '') {
      this.filteredKsgGames = [...this.ksgGames];
    } else {
      this.filteredKsgGames = this.ksgGames.filter(game => 
        game.name.toLowerCase().includes(this.gameFilter.toLowerCase())
      );
    }
  }
  clearFilter(): void {
    this.gameFilter = '';
    this.filterGames();
  }

  protected appVersion = this.store.state.version;
  protected ksgGames: Game[] = [];
  protected filteredKsgGames: Game[] = [];
  protected gameFilter = "";
  created(): void {
    if (this.parameters.game != null) {
      this.parameters.game = null;
    }
    this.ksgGames = [];
    let games: GameDataType[] = [];
    let environmentDatas: EnvironmentType[] = [];
    let languages: Language[] = undefined;
    let currencies: string[] = undefined;
    let buildPrefixes: string[] = [];
    const noCacheString = generateNoCacheString();
    this.$http
      .get(
        `${Constants.AWS_URL}/frontend-lobby/data/ksg.json` +
          noCacheString
      )
      .then((response) => {
        const data: AppDataType = response.data;
        games = data[Constants.GAMES];
        environmentDatas = data[Constants.ENVIRONMENTS];
        buildPrefixes = data[Constants.BUILD_PREFIXES];
        if (data[Constants.LANGUAGES]) {
          languages = [];
          for (let languageData of data[Constants.LANGUAGES]) {
            languages.push(new Language(languageData));
          }
        }
        currencies = data[Constants.CURRENCIES];
      })
      .catch(() =>
        this.$http
          .get("../data/ksg.json" + noCacheString)
          .then((response) => {
            const data: AppDataType = response.data;
            games = data[Constants.GAMES];
            environmentDatas = data[Constants.ENVIRONMENTS];
            buildPrefixes = data[Constants.BUILD_PREFIXES];
            if (data[Constants.LANGUAGES]) {
              languages = [];
              for (let languageData of data[Constants.LANGUAGES]) {
                languages.push(new Language(languageData));
              }
            }
            currencies = data[Constants.CURRENCIES];
          })
      )
      .finally(() => {
        if (environmentDatas.length > 0 && games.length > 0) {
          const environmentMap: Record<string, Environment> = {};
          for (let environmentData of environmentDatas) {
            const env = new Environment(environmentData);
            environmentMap[env.id] = env;
          }
          const environments = Object.values(environmentMap);

          for (let gameData of games) {
            this.ksgGames.push(new Game(gameData));
          }
          this.filteredKsgGames = [...this.ksgGames]
          this.store.state.environments = environments;
          this.store.state.games = this.ksgGames;
          this.store.state.mock = true;
          this.store.state.languages = languages ?? this.store.state.languages;
          this.parameters.language = languages[0];
          this.store.state.currencies =
            currencies ?? this.store.state.currencies;
          this.store.state.buildPrefixes = buildPrefixes ?? this.store.state.buildPrefixes;

          const environment = environmentMap[localStorageGetOrDefault("environment_id", environments[0].id)];
          this.parameters.environment = environment;
          this.parameters.prototypeUrl =
            environment.clientAddress ||
              `${Constants.AWS_URL}/frontend/`;
        }
      });
  }
}
